import React, { memo } from 'react';
import { ChartIcons, ClipBoardIcons, FilterIcons } from '../../../../../../icons/icons';

interface FilterButtonGroupProps {
  onJDClick: () => void;
  onPreQualClick: () => void;
  onCCAClick: () => void;
  isJDActive: boolean;
  isPreQualActive: boolean;
  isCCAActive: boolean;
}

export const FilterButtonGroup = memo<FilterButtonGroupProps>(({
  onJDClick,
  onPreQualClick,
  onCCAClick,
  isJDActive,
  isPreQualActive,
  isCCAActive,
}) => {
  return (
    <div className='flex items-center overflow-hidden rounded-lg border border-slate-200 bg-slate-100/70 p-0.5 shadow-sm'>
      { /* JD Filter Button */ }
      <button
          onClick={onJDClick}
          className={`flex min-h-8 items-center gap-1.5 rounded-md px-2 py-1 transition-all duration-300 ${
            isJDActive
              ? 'bg-white text-emerald-600 shadow-md shadow-emerald-500/5 ring-1 ring-slate-200/50'
              : 'text-slate-500 hover:text-slate-700 hover:bg-white/40'
          }`}
          title='Job Description Filters'
      >
        <FilterIcons className={`w-3 h-3 ${isJDActive ? 'text-emerald-500' : 'text-slate-400'}`} />
        <span className='text-[10px] font-black uppercase tracking-widest'>JD</span>
      </button>

      <div className='w-px h-4 bg-slate-200 mx-0.5 self-center' />

      { /* PreQual Filter Button */ }
      <button
          onClick={onPreQualClick}
          className={`flex min-h-8 items-center gap-1.5 rounded-md px-2 py-1 transition-all duration-300 ${
            isPreQualActive
              ? 'bg-white text-emerald-600 shadow-md shadow-emerald-500/5 ring-1 ring-slate-200/50'
              : 'text-slate-500 hover:text-slate-700 hover:bg-white/40'
          }`}
          title='Pre-Qualification Filters'
      >
        <ClipBoardIcons className={`w-3 h-3 ${isPreQualActive ? 'text-emerald-500' : 'text-slate-400'}`} />
        <span className='text-[10px] font-black uppercase tracking-widest'>PreQual</span>
      </button>

      <div className='w-px h-4 bg-slate-200 mx-0.5 self-center' />

      { /* CCA Filter Button */ }
      <button
          onClick={onCCAClick}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all duration-300 ${
            isCCAActive
              ? 'bg-white text-violet-600 shadow-md shadow-violet-500/5 ring-1 ring-slate-200/50'
              : 'text-slate-500 hover:text-slate-700 hover:bg-white/40'
          }`}
          title='CCA Filters'
      >
        <ChartIcons className={`w-3.5 h-3.5 ${isCCAActive ? 'text-violet-500' : 'text-slate-400'}`} />
        <span className='text-[10px] font-black uppercase tracking-widest'>CCA</span>
      </button>
    </div>
  );
});

FilterButtonGroup.displayName = 'FilterButtonGroup';
